import { fetcher } from "helpers/fetcher";

import { TDeleteAddressReq, TDeleteAddressRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const deleteAddress = async (payload: TDeleteAddressReq) => {
  return await fetcher<TDeleteAddressRes, TDeleteAddressReq["data"]>(
    ENDPOINT.USER.DELETE_ADDRESS,
    {
      data: payload.data,
      headers: {
        [API_HEADER.USER_ID]: payload.idUser,
        [API_HEADER.VERSION]: ENDPOINT.USER.DELETE_ADDRESS.version,
      },
    }
  );
};

export const mutationDeleteAddress = async (payload: TDeleteAddressReq) => {
  return (await deleteAddress(payload)).data.message;
};

mutationDeleteAddress._key = (payload: TDeleteAddressReq) => [
  ENDPOINT.USER.DELETE_ADDRESS.url,
  payload,
];
